<template>
      <div no-body class="lku-charges"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col cols="11">
          <b-form-group label-cols=1 label="Filter" >
            <b-form-row>
              <b-col cols="5">
                  <b-form-input v-model="tblData.namabank" placeholder="Bank/Cash Acc. Name" @keyup.13.native="refresh()"></b-form-input>
              </b-col>
              <b-col cols="4">
                  <b-form-input v-model="tblData.kode" placeholder="Bank/Cash Acc. Code" @keyup.13.native="refresh()"></b-form-input>
              </b-col>
            </b-form-row>
          </b-form-group>
          </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblBankcash" style="font-size:smaller;" 
          responsive striped hover
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
        <template v-slot:cell(kode)="data">
            <span v-if="(data.item.isbank==1)">{{data.item.kode}}</span>
            <span v-else style="color:green;">{{data.item.kode}}</span>
        </template>  
        <template v-slot:cell(namabank)="data">
            <span v-if="(data.item.isbank==1)">{{data.item.namabank}}</span>
            <span v-else style="color:green;">{{data.item.namabank}}</span>
        </template>  
        <template v-slot:cell(matauang)="data">
            <span v-if="(data.item.isbank==1)">{{data.item.matauang}}</span>
            <span v-else style="color:green;">{{data.item.matauang}}</span>
        </template>  
        <template v-slot:cell(namabank2)="data">
            <span v-if="(data.item.isbank==1)">{{data.item.namabank2}}</span>
        </template>  
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>

<script>
import bankcashacc from "../../apis/bankcashacc";
import dropdown from "../../data/dropdown";

export default {
  data() {
    return {
      fields: [
        {
          key: "kode",
          thStyle: "width:100px",
          label: "Account Code",
          sortable: true
        },
        {
          key: "namabank",
          label: "Account Name",
          sortable: true
        },
        {
          key: "matauang",
          thStyle: "width:40px",
          label: "CCY",
          sortable: true
        },
        {
          key: "nomorrek",
          label: "Nomor Rekening",
          sortable: true
        },
        {
          key: "cabang",
          label: "Cabang",
          sortable: true
        },
      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'namabank',
        sortDesc: false,aktif:'1',isbank:''
      },
      dataList: {
        YesNo: dropdown.YesNo,
        YesNoAll: dropdown.YesNoAll,
        BankOrCash: [{value: '0', text: 'CASH'}, {value: '1', text: 'BANK'}],
        BankOrCashAll: [{value: '', text: '-ALL-'},{value: '0', text: 'CASH'}, {value: '1', text: 'BANK'}],
      },      
      lkuLoading:false
    };
  },
  computed: {
    showingLabel() {
      const { tblData } = this;
      const { page, limit, total } = tblData;

      const val1 = (page - 1) * limit + 1;
      const val2 = page * limit < total ? page * limit : total;
      return `Showing ${val1} to ${val2} of ${total} entries`;
    },
  },
  props: ["isbank","isVAAccount"],
  created: async function() {
      this.$emit('update:isbank', '');
  },

  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.isbank=this.isbank;
      this.tblData.isVAAccount=this.isVAAccount;
      this.lkuLoading=true;
      const list = await bankcashacc.list(this.tblData);      
      console.log('list',list)
      this.lkuLoading=false;
      return list;
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData={kode:'', namabank: ''};
        this.refresh();
    },    
    keymonitor: function(event) {
        // console.log(event.key);
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblBankcash.refresh();
       }
    },    
    refresh() {
      this.$refs.tblBankcash.refresh();
    }
  }
};
</script>
